
document.querySelector('.custom-hamburger').addEventListener('click', function() {
            document.querySelector('.custom-menu').classList.toggle('show');
        });
        
        document.querySelector('.custom-close').addEventListener('click', function() {
            document.querySelector('.custom-menu').classList.remove('show');
        });
        
        document.querySelectorAll('.custom-submenu-toggle').forEach(toggle => {
            toggle.addEventListener('click', function(event) {
                event.stopPropagation();
                let submenu = this.nextElementSibling;
                if (submenu) {
                    submenu.classList.toggle('show');
                }
            });
          
        });

document.addEventListener("DOMContentLoaded", function () {
    const pageHeader = document.querySelector(".page-header");
    const headerLogo = document.querySelector(".header__logo");

    if (pageHeader && headerLogo) {
        const observer = new MutationObserver(() => {
            if (pageHeader.classList.contains("header_scroll_down")) {
                headerLogo.classList.add("d-none");
            } else {
                headerLogo.classList.remove("d-none");
            }
        });

        observer.observe(pageHeader, { attributes: true, attributeFilter: ["class"] });
    }
});
